import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class CategoryBlog extends Page{
    constructor(){
        super({
            id : 'category_blog',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}